/*--------------------
* About Section
----------------------*/
const STATS = [
  { value: "7+", label: "Products shipped" },
  { value: "100+", label: "Happy users" },
  { value: "∞", label: "Ideas in the queue" },
];

function TerminalCard() {
  return (
    <div className="glass-card overflow-hidden text-left font-mono text-[13px] md:text-[14px] leading-[2]">
      <div className="flex items-center gap-2 px-5 py-3 border-b border-white/[0.06] bg-night-900/60">
        <span className="w-[10px] h-[10px] rounded-full bg-[#ff5f57]"></span>
        <span className="w-[10px] h-[10px] rounded-full bg-[#febc2e]"></span>
        <span className="w-[10px] h-[10px] rounded-full bg-[#28c840]"></span>
        <span className="ml-3 text-mist-500 text-[12px]">
          twilight-tier — zsh
        </span>
      </div>
      <div className="p-6">
        <p>
          <span className="text-ember-400">$</span>{" "}
          <span className="text-mist-100">twilight new venture</span>
        </p>
        <p className="text-mist-400">→ scanning shower thoughts…</p>
        <p className="text-mist-400">→ validating with real humans…</p>
        <p className="text-mist-400">→ designing, building, shipping…</p>
        <p>
          <span className="text-[#28c840]">✓</span>{" "}
          <span className="text-mist-100">venture launched.</span>{" "}
          <span className="text-mist-500">(repeat)</span>
        </p>
        <p>
          <span className="text-ember-400">$</span>{" "}
          <span className="inline-block w-[9px] h-[17px] bg-ember-400 align-middle animate-twinkle"></span>
        </p>
      </div>
    </div>
  );
}

export default function About() {
  return (
    <section id="about" className="section bg-night-950">
      <div className="container">
        <div className="grid lg:grid-cols-12 grid-cols-1 gap-12 items-center">
          <div className="lg:col-span-6 order-last lg:order-first">
            <TerminalCard />
          </div>
          <div className="lg:col-span-6">
            <p className="eyebrow">01 — Who we are</p>
            <h2 className="text-[32px] md:text-[44px] font-[600] leading-[1.15] mt-4 mb-6">
              We are makers.
            </h2>
            <p className="text-[16px] md:text-[18px] leading-relaxed mb-5">
              Twilight Tier is the company behind the side projects that
              refused to stay side projects. We take ideas from napkin sketch
              to shipped product — design, code, launch, and everything in
              between.
            </p>
            <p className="text-[16px] md:text-[18px] leading-relaxed mb-10">
              From idea to execution, we love doing it all. We build things we
              actually want to use, and we keep building until they matter.
            </p>
            <div className="grid grid-cols-3 gap-6">
              {STATS.map((stat) => (
                <div key={stat.label}>
                  <h5 className="text-[28px] md:text-[34px] font-[700] gradient-text">
                    {stat.value}
                  </h5>
                  <span className="text-[13px] md:text-[14px] text-mist-500">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
